import ValidateError from './ValidateError';

export class ArrayLengthWrongLengthValidationError extends ValidateError {
  constructor(key, length, value) {
    super('error.array_length.not_is', key);
    Object.assign(this._data, { length, value });
  }
}

export class ArrayLengthTooLongValidationError extends ValidateError {
  constructor(key, length, value) {
    super('error.array_length.too_short', key);
    Object.assign(this._data, { length, value });
  }
}

export class ArrayLengthTooShortValidationError extends ValidateError {
  constructor(key, length, value) {
    super('error.array_length.too_long', key);
    Object.assign(this._data, { length, value });
  }
}

const arrayLength = function(value = [], options, key) {
  let { is, minimum, maximum, name = key } = options;

  if (is !== undefined && value.length !== is) {
    return options.message || new ArrayLengthWrongLengthValidationError(name, value.length, is);

  } else if (minimum !== undefined && value.length < minimum) {
    return options.message || new ArrayLengthTooLongValidationError(name, value.length, minimum);

  } else if (maximum !== undefined && value.length > maximum) {
    return options.message || new ArrayLengthTooLongValidationError(name, value.length, maximum);

  }
};

export default arrayLength;



// WEBPACK FOOTER //
// ./src/utilites/validate/arrayLength.js